// 📄 ResearchCitation.jsx

import CitationLabel from './CitationLabel';

const ResearchCitation = ({ type }) => {
  if (type === 'MCID') {
    return (
      <p>
        <CitationLabel>Research evidence</CitationLabel>
        Smeltzer, J. C., Stipancic, K. L., & Toles, L. E. (2025). <em>Minimal Clinically Important Differences in CAPE-V Auditory–Perceptual Ratings of Voice Quality</em>. <em>Journal of Speech, Language, and Hearing Research, 68</em>(5), 2275–2290. <a href="https://doi.org/10.1044/2024_JSLHR-23-00456" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2024_JSLHR-23-00456</a>
      </p>
    );
  }

  if (type === 'ANCHORS_PRELIMINARY_RESULTS_ABSTRACT') {
    return (
      <p>
        <CitationLabel>Based on the preliminary results reported in</CitationLabel>
        Calaf, N., & Garcia-Quintana, D. (2024). Establishing consensus anchors for enhanced auditory-perceptual voice evaluation: A methodological framework. Abstract submitted to the 2024 American Speech-Language-Hearing Association (ASHA) Convention, Seattle, WA.
      </p>
    );
  }

  if (type === 'ANCHORS_PRELIMINARY_RESULTS_CONVENTION') {
    return (
      <p>
        <CitationLabel>Based on the preliminary results reported in</CitationLabel>
        Calaf, N., & Garcia-Quintana, D. (2024). Establishing consensus anchors for enhanced auditory-perceptual voice evaluation: A methodological framework. 2024 American Speech-Language-Hearing Association (ASHA) Convention, Seattle, WA.
      </p>
    );
  }

  return null;
};

export default ResearchCitation;
